module.exports = __webpack_public_path__ + "img/SG.29f5f9ab.png";